import {TokenService} from '../services/storage.service'
import axios from 'axios'

const ApiService = {
    init(baseURL){
        axios.defaults.baseURL = baseURL;

        axios.interceptors.response.use(
            response => response,
            error => {
                if (error.response && error.response.status === 401) {
                    // TokenService.removeToken();
                    // TokenService.removePermissions();
                    // if (window.location.pathname !== "/") {
                    //     window.location.href = "/";
                    // }
                }

                return Promise.reject(error);
            }
        );
    },
    setHeader(){
        // get date time in yyyymmddhhmm format
        const now = new Date();
        const dateTime = now.toISOString().slice(0, 16).replace("T", "").replace(/-/g, "").replace(/:/g, "");

        let encryptedDeviceToken = TokenService.getDeviceToken()+'(lxy)'+dateTime;
        encryptedDeviceToken = btoa(encryptedDeviceToken);

        axios.defaults.headers = {
            // 'Content-Type': 'application/json',
            Authorization: `Bearer ${TokenService.getToken()}`,
            "correlation-xtd": TokenService.getDeviceToken(),
            "textoxtra": encryptedDeviceToken
        }
        // axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
    },
    removeHeader(){
        axios.defaults.headers.common = {};
    },
    get(resource){
        this.setHeader();
        return axios.get(resource);
    },
    post(resource,data){
        this.setHeader();
        return axios.post(resource,data);
    },
    postConfig(resource,data,config){
        this.setHeader();
        return axios.post(resource,config);
    },
    put(resource,data){
        this.setHeader();
        return axios.put(resource,data);
    },
    delete(resource){
        this.setHeader();
        return axios.delete(resource);
    },
    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data){
        return axios(data)
    }

}
export default ApiService
